export default __webpack_public_path__ + "static/media/onboarding1.6e7d3702.svg";